// export const CREATE = 'CREATE';
// export const UPDATE = 'UPDATE';
// export const DELETE = 'DELETE';
// export const FETCH_ALL = 'FETCH_ALL';
// export const LIKE = 'LIKE';
//Donor
export const FETCH_DONOR='FETCH_DONOR';
export const DELETE_DONOR='DELETE_DONOR';
export const APPROVE_DONOR='APPROVE DONNOR';
export const BLOCK_DONOR='BLOCK_DONOR';
export const UNBLOCK_DONOR='UNBLOCK_DONOR';

//Needy
export const FETCH_NEEDY='FETCH_NEEDY';
export const DELETE_NEEDY='DELETE_NEEDY';
export const APPROVE_NEEDY='APPROVE _NEEDY';
export const BLOCK_NEEDY='BLOCK_NEEDY';
export const UNBLOCK_NEEDY='UNBLOCK_NEEDY';


//Categories
export const FETCH_CATEGORIES='FETCH_CATEGORIES';
export const DELETE_CATEGORIES='DELETE_CATEGORIES';
export const ADD_CATEGORY='ADD_CATEGORY';